export const translations = {
  settings: {
    backFromSettings: {
      'en-150': 'Back to events',
      'sk-SK': 'Späť na udalosti'
    },
    settingsLabel: {
      'en-150': 'Application settings',
      'sk-SK': 'Nastavenia aplikácie'
    },
    loginSettingsLabel: {
      'en-150': 'Login',
      'sk-SK': 'Prihlásenie'
    },
    languageSettingsLabel: {
      'en-150': 'Language settings',
      'sk-SK': 'Nastavenia jazyka'
    },
    languageSelectLabel: {
      'en-150': 'Choose a language',
      'sk-SK': 'Vybrať jazyk'
    },
    logout: {
      'en-150': 'Logout',
      'sk-SK': 'Odhlásiť sa'
    },
    loggedInAs: {
      'en-150': 'You are logged in as',
      'sk-SK': 'Ste prihlásený ako'
    },
    applicationLabel: {
      'en-150': 'Application',
      'sk-SK': 'Aplikácia'
    },
    applicationVersion: {
      'en-150': 'Current version',
      'sk-SK': 'Aktuálna verzia'
    }
  }
}
